<template>
	<transition name="fade">
		<div v-if="showing" class="qf-loading-spinner">
			<ons-progress-circular indeterminate></ons-progress-circular> <span class="qf-loading-text">{{message}}</span>
		</div>
	</transition>
</template>

<script>
	export default {
		name: "QfSpinner",
		props: {
			showing : {
				type: Boolean,
				default: false
			},
			message: {
				type: String,
				default: 'Loading'
			}
		}
	}
</script>

<style scoped>
	.qf-loading-spinner {
		width: 100%;
		position: fixed;
		top: calc(50% - 80px);
		height: 90px;
		background-color: rgba(0,0,0,0.8);
		text-align: center;
		padding-top: 25px;
		font-weight: bold;
		z-index: 99999;
	}
	.qf-loading-text {
		display: block;
		margin-top: 10px;
		position: relative;
	}
</style>
